module.exports = __webpack_public_path__ + "static/RootSans-13Ultra-5a16774bd1edfdf5dc7b0db2664a326c.woff";